import { render, staticRenderFns } from "./film.vue?vue&type=template&id=4a543070&scoped=true"
import script from "./film.vue?vue&type=script&lang=js"
export * from "./film.vue?vue&type=script&lang=js"
import style0 from "./film.vue?vue&type=style&index=0&id=4a543070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a543070",
  null
  
)

export default component.exports